import request from '@/utils/request'

// post /api/v1/admin/money_management/payin_history 存款管理列表
export function getPayinHistory(data) {
  return request({
    url: '/api/v1/admin/payment/payin/history',
    method: 'post',
    mock: false,
    data,
  })
}

// post /api/v1/admin/money_management/payout_history 提款管理列表
export function getPayoutHistory(data) {
  return request({
    url: '/api/v1/admin/payment/payout/history',
    method: 'post',
    mock: false,
    data,
  })
}

// post /api/v1/admin/money_management/modify_player_gold_list 手动上下分列表
export function getModifyPlayerGoldList(data) {
  return request({
    url: '/api/v1/admin/payment/gold/list',
    method: 'post',
    mock: false,
    data,
  })
}

export function getWinLossInfo(data) {
  return request({
    url: '/api/v1/admin/members/member_list/bet_logs',
    method: 'post',
    mock: false,
    data,
  })
}

// 数据概览
export function getDataOverview(data) {
  return request({
    url: '/api/v1/admin/members/member_list/data_overview',
    method: 'post',
    mock: false,
    data,
  })
}

// 投注列表查询（投注管理主界面 + 会员游戏记录详情）
export function getBetList(data) {
  return request({
    url: '/api/v1/admin/game_config/game_bet/list',
    method: 'post',
    mock: false,
    data,
  })
}

// post /api/v1/admin/payment/payout/refund 提款退款
export function payoutRefund(data) {
  return request({
    url: '/api/v1/admin/payment/payout/refund',
    method: 'post',
    mock: false,
    data,
  })
}

// post /api/v1/admin/payment/payout/approve 提款审核
export function payoutApprove(data) {
  return request({
    url: '/api/v1/admin/payment/payout/approve',
    method: 'post',
    mock: false,
    data,
  })
}

// post /api/v1/admin/payment/payout/approve_overview 提款审核风控信息概览
export function getPayoutApproveOverview(data) {
  return request({
    url: '/api/v1/admin/payment/payout/approve_overview',
    method: 'post',
    mock: false,
    data,
  })
}

// 存款历史导出（仅返回 list，无表头，见 parseExportList）
export function exportPayinHistory(data) {
  return request({
    url: '/api/v1/admin/payment/payin/export',
    method: 'post',
    mock: false,
    data,
  })
}

// 提款历史导出（列配置见 financeExport.PAYOUT_EXPORT_COLUMNS）
export function exportPayoutHistory(data) {
  return request({
    url: '/api/v1/admin/payment/payout/export',
    method: 'post',
    mock: false,
    data,
  })
}
